export const EVENT_TYPES = [
    { value: "addClient", label: "Add Client" },
    { value: "activateClient", label: "Activate Client" },
    { value: "rejectClient", label: "Reject Client" },
    { value: "birthday", label: "Birthday" },
    { value: "createLoan", label: "Create Loan" },
    { value: "approveLoan", label: "Approve Loan" },
    { value: "disburseLoan", label: "Disburse Loan" },
    { value: "rejectLoan", label: "Reject Loan" },
    { value: "overdueLoan", label: "Overdue Loan" },
    { value: "installmentAlert", label: "Installment Alert" },
    { value: "addPayment", label: "Add Payment" },
];

export const PLACEHOLDER_GROUPS = [
    {
        key: "client",
        label: "Client",
        fields: [
            "id",
            "display_name",
            "first_name",
            "last_name",
            "gender",
            "dob",
            "mobile_num",
            "id_num",
            "musoni_system_id"
        ]
    },
    {
        key: "loan",
        label: "Loan",
        fields: ["id", "status", "accountNo", "loanProductName", "totalOutstanding", "totalOverdue", "nextInstallmentDate", "nextInstallmentBalance"]
    },
    {
        key: "payment",
        label: "Payment",
        fields: ["id", "currency", "amount"]
    }
];

export const CLIENT_ONLY_EVENT_TYPES = new Set(["addClient", "activateClient", "rejectClient", "birthday"]);

const LOAN_EVENT_TYPES = new Set(["createLoan", "approveLoan", "disburseLoan", "rejectLoan", "overdueLoan", "installmentAlert"]);

const PAYMENT_EVENT_TYPES = new Set(["addPayment"]);

const PLACEHOLDER_KEYS_BY_EVENT = new Map([
    ...Array.from(CLIENT_ONLY_EVENT_TYPES, (eventType) => [eventType, ["client"]]),
    ...Array.from(LOAN_EVENT_TYPES, (eventType) => [eventType, ["client", "loan"]]),
    ...Array.from(PAYMENT_EVENT_TYPES, (eventType) => [eventType, ["client", "loan", "payment"]])
]);

export const getPlaceholderGroupsForEvent = (eventType) => {
    if (!eventType) {
        return PLACEHOLDER_GROUPS;
    }

    const allowedKeys = PLACEHOLDER_KEYS_BY_EVENT.get(eventType);

    if (!allowedKeys) {
        return PLACEHOLDER_GROUPS;
    }

    return PLACEHOLDER_GROUPS.filter(({ key }) => allowedKeys.includes(key));
};
